import { render, staticRenderFns } from "./OverallStats.vue?vue&type=template&id=2ff27f4e&scoped=true"
import script from "./OverallStats.vue?vue&type=script&lang=js"
export * from "./OverallStats.vue?vue&type=script&lang=js"
import style0 from "./OverallStats.vue?vue&type=style&index=0&id=2ff27f4e&prod&lang=scss&scoped=true"
import style1 from "./OverallStats.vue?vue&type=style&index=1&id=2ff27f4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff27f4e",
  null
  
)

export default component.exports